export default "__VITE_ASSET__5e4274df__"